export default {
  'common.search': 'Search',
  'common.explore': 'Explore',
  'common.login': 'Login',
  'common.logout': 'Logout',
  'common.register': 'Register',
  'common.submit': 'Submit',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.loading': 'Loading...',
  'common.processing': 'Processing...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.warning': 'Warning',
  'common.info': 'Information',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.view': 'View',
  'common.edit': 'Edit',
  'common.filters': 'Filters',
  'common.reset': 'Reset',
  'common.apply': 'Apply',
  'common.confirmation': 'Confirmation',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.language': 'Language',
  'common.currency': 'Currency',
  'common.settings': 'Settings',
  'common.profile': 'Profile',
  'common.dashboard': 'Dashboard',
  'common.account': 'Account',
  'common.home': 'Home',
  'common.contact': 'Contact',
  'common.about': 'About',
  'common.help': 'Help',
  'common.faq': 'FAQ',
  'common.login_required': 'Login Required',
  'common.login_to_continue': 'Please log in to continue',
  'common.login_to_favorite': 'Please log in to add favorites',
  'common.login_to_message': 'Please log in to send messages',
  'common.login_to_book': 'Please log in to book appointments',
  'common.email': 'Email',
  'common.password': 'Password',
  'common.remember_me': 'Remember Me',
  'common.forgot_password': 'Forgot Password?',
  'common.no_account': 'Don\'t have an account?',
  'common.have_account': 'Already have an account?',
  'common.agree_terms': 'I agree to the terms and conditions',
  'common.error_starting_conversation': 'Could not start conversation. Please try again later.',
  'common.login_signup': 'Login / Sign Up',
  'common.and': 'and',
  'common.error_occurred': 'An error occurred',
  'common.verified': 'Verified',
  'common.not_verified': 'Not Verified',
  'common.error_loading_data': 'Error loading data',
  'common.unknown_error': 'Unknown error',
  'common.choose_conversation': 'Choose a conversation to start chatting',
  'common.retry': 'Retry',
  'search.no_profiles_found': 'No Profiles Found',
  'search.no_profiles_message': 'Try adjusting your filters or check back later.',
  'gender.female': 'Female',
  'gender.male': 'Male',
  'gender.trans': 'Transgender',
  'gender.trans_female': 'Trans Female',
  'gender.trans_male': 'Trans Male',
  'gender.non_binary': 'Non-Binary',
  'Login': 'Login',
  'Register': 'Register',
  'Terms of Service': 'Terms of Service',
  'Privacy Policy': 'Privacy Policy',
  'Join Now': 'Join Now',
  'Sign in': 'Sign in',
  'Name': 'Name',
  'Your name': 'Your name',
  'Email': 'Email',
  'Your email address': 'Your email address',
  'Password': 'Password',
  'Your password': 'Your password',
  'Confirm Password': 'Confirm Password',
  'Confirm your password': 'Confirm your password',
  'I agree to the': 'I agree to the',
  'Create Account': 'Create Account',
  'Account type': 'Account type',
  'Client': 'Client',
  'Escort': 'Escort',
  'Verified': 'Verified',
  'Online': 'Online',
  'Touring': 'Touring',
  'View Profile': 'View Profile',
  'Message': 'Message',
  'profile.private_access': 'Private Access',
  'common.touring': 'Touring',
  'common.registered_date_prefix': 'Registered on',
  'common.profile.last_online': 'Last online',
  'common.today': 'today',
  'common.total_views': 'Total views',
  'common.admin.tabs.users': 'Users',
  'common.admin.tabs.reports': 'Reports',
  'common.admin.tabs.verifications': 'Verifications',
  'common.admin.tabs.supabase': 'Supabase',
  'ethnicity.asian': 'Asian',
  'ethnicity.black': 'Black',
  'ethnicity.caucasian': 'Caucasian',
  'ethnicity.hispanic_latino': 'Hispanic/Latino',
  'ethnicity.middle_eastern': 'Middle Eastern',
  'ethnicity.native_american': 'Native American',
  'ethnicity.pacific_islander': 'Pacific Islander',
  'ethnicity.mixed': 'Mixed',
  'ethnicity.other': 'Other',
  'body_type.slim': 'Slim',
  'body_type.athletic': 'Athletic',
  'body_type.average': 'Average',
  'body_type.curvy': 'Curvy',
  'body_type.bbw': 'BBW/Plus-size',
  'body_type.muscular': 'Muscular',
  'body_type.petite': 'Petite',
  'orientation.heterosexual': 'Heterosexual',
  'orientation.homosexual': 'Homosexual',
  'orientation.bisexual': 'Bisexual',
  'orientation.pansexual': 'Pansexual',
  'orientation.asexual': 'Asexual',
};
